// extracted by mini-css-extract-plugin
export default {"loyaltyMembersDayBanner":"loyaltyMembersDayBanner_w2Bfg"};